<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     增值服务列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ei-rms padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <el-select v-model="query.active_status" placeholder="激活状态" filterable clearable style="width: 120px;" @change="fetchData(1)">
            <el-option
              v-for="item in activeStatusArr"
              :key="item.key"
              :label="item.value"
              :value="item.key" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select v-model="query.rms_status" placeholder="服务状态" filterable clearable style="width: 120px;" @change="fetchData(1)">
            <el-option
              v-for="item in status"
              :key="item.key"
              :label="item.value"
              :value="item.key" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select v-model="query.rms_schemeid" placeholder="收费方案" filterable clearable style="width: 160px;" @change="fetchData(1)">
            <el-option
              v-for="plan in schemes"
              :key="plan.schemeid"
              :label="plan.title"
              :value="plan.schemeid" />
          </el-select>
        </div>
        <div class="filter-item" style="width: 160px;">
          <el-input v-model="query.keyword" placeholder="名称 / GO" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
        <div v-show="allFilterShow" class="filter-item">
          <el-select v-model="query.tagid" placeholder="标签" filterable clearable style="width: 140px;" @change="fetchData(1)">
            <el-option
              v-for="item in tags"
              :key="item.tagid"
              :label="item.title"
              :value="item.tagid" />
          </el-select>
        </div>
        <div v-show="allFilterShow" class="filter-item">
          <f-dev-selector v-model="query.devid" placeholder="模型" width="160" @change="fetchData(1)" />
        </div>

        <el-button
          v-if="!allFilterShow"
          icon="el-icon-more"
          :type="query.tagid || query.devid ? 'primary' : 'default'"
          circle
          class="circle-btn"
          @click="showAllFilter(1)"
        />
        <el-button
          v-else
          icon="el-icon-arrow-left"
          circle
          class="circle-btn"
          @click="showAllFilter(0)"
        />
      </div>

      <div class="toolbox">
        <el-link :underline="false" type="warning" @click="toDoc"><i class="el-icon-question font-md" /> 了解服务管理</el-link>
        <f-sort-selector v-model="query.sort" :options="sortOptions" width="80" @change="fetchData(1)" class="ml-sm"/>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never" class="mb-md">
      <el-table
        ref="equipsTable"
        :data="equips"
        tooltip-effect="dark"
        class="padding-small"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" />

        <el-table-column width="60">
          <template slot-scope="scope">
            <f-equip-avatar :equip="scope.row" />
          </template>
        </el-table-column>

        <el-table-column label="设备" min-width="200">
          <template slot-scope="scope">
            <div class="flex">
              <f-equip-name :equip="scope.row" />
              <tag-panel
                v-if="allFilterShow"
                :ref="'tagPanel' + scope.row.equipid"
                class="ml-sm"
                type="equip"
                readonly
                :unique-key="scope.row.equipid"
                :title="scope.row.name"
                :tags="scope.row.tags"
              />
            </div>
            <div v-if="allFilterShow && scope.row.devid" style="line-height: 17px; height: 17px;">
              <f-dev-name
                :dev="{ devid: scope.row.devid, dev_name: scope.row.dev_name }"
                class="font-sm text-muted"
              />
            </div>
          </template>
        </el-table-column>

       <el-table-column label="激活状态" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.active_status == 1" type="warning">未激活</el-tag>
            <el-tag v-if="scope.row.active_status == 2" type="success">已激活</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="服务状态" min-width="120" >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.rms_status === 1" type="success">正常</el-tag>
            <el-tag v-if="scope.row.rms_status === 2" type="danger">已过期</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="有效期" min-width="120" >
          <template slot-scope="scope">
            <span v-if="scope.row.rms_expiretime">{{ scope.row.rms_expiretime | parseTime('{y}/{m}/{d}') }}</span>
            <span v-else>长期</span>
          </template>
        </el-table-column>

        <el-table-column label="收费方案" min-width="160">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.rms_schemeid"
              placement="left"
              width="280"
              trigger="hover"
              >
              <div class="font-md">{{ schemesObj[scope.row.rms_schemeid].title }}</div>
              <div class="mt">
                <span class="text-danger font-lg mr-xs">{{ schemesObj[scope.row.rms_schemeid].scheme_price | currency }}</span>
                <span v-if="schemesObj[scope.row.rms_schemeid].scheme_unit == 'year'" class="text-muted">/ 年</span>
                <span v-if="schemesObj[scope.row.rms_schemeid].scheme_unit == 'month'" class="text-muted">/ 月</span>
                <span v-if="schemesObj[scope.row.rms_schemeid].scheme_unit == 'once'" class="text-muted">/ 一次性</span>
              </div>
              <span slot="reference">{{ schemesObj[scope.row.rms_schemeid].title }}</span>
            </el-popover>
          </template>
        </el-table-column>
    
        <el-table-column prop="relater" label="绑定用户" width="240">
          <template slot-scope="scope">
            <el-popover
              placement="right"
              width="400"
              trigger="hover">
              <el-table
                ref="membersTable"
                :data="scope.row.members"
                tooltip-effect="dark"
                class="padding-small"
                style="width: 100%"
                max-height="500">
                <el-table-column type="index" label="#" width="40" />

                <el-table-column label="用户" width="60">
                  <template slot-scope="item">
                    <f-user-avatar :src="item.row.avatar" :preview="false" />
                  </template>
                </el-table-column>

                <el-table-column min-width="160" label="#">
                  <template slot-scope="item">
                    <f-user-name class="ml-sm" :user="item.row" style="margin-left: -10px;" />
                  </template>
                </el-table-column>

                <el-table-column label="权限" width="100">
                  <template slot-scope="item">
                    {{ authObj[item.row.member_auth].title }}
                  </template>
                </el-table-column>
              </el-table>
  
              <div slot="reference">
                <f-user-avatar v-if="scope.row.members.length" :src="scope.row.members[0].avatar" :preview="false" />
                <f-user-avatar v-if="scope.row.members.length > 1" class="ml-xs" :src="scope.row.members[1].avatar" :preview="false" />
                <f-user-avatar v-if="scope.row.members.length > 2" class="ml-xs" :src="scope.row.members[2].avatar" :preview="false" />
                <span v-if="scope.row.members.length > 3" class="ml-xs">等{{ scope.row.members.length }}人</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="primary" plain round size="small" @click="showSingleSetDialog(scope.row)">设置</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>

    <el-dialog
      v-if="dialogShow"
      width="600px"
      title="服务设置"
      :visible.sync="dialogShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false">

      <div style="width: 440px; margin: 20px auto">
        <el-form
          ref="postForm"
          v-loading="posting"
          class="mt-lg"
          label-position="left"
          label-width="100px"
          :model="formData"
        >
          <el-form-item label="设备名称" prop="expiretime">
            <span>{{ activeRow.equip_name }}</span>
          </el-form-item>

          <el-form-item label="收费方案">
            <el-select v-model="formData.rms_schemeid" filterable placeholder="可选" clearable style="width: 240px;">
              <el-option
                v-for="item in schemes"
                :key="item.schemeid"
                :label="item.title"
                :value="item.schemeid">
                <span>{{ item.title }}</span>
                <span v-if="item.scheme_unit === 'year'" class="ml">
                  {{ item.scheme_price | currency }} / 年
                </span>
                <span v-if="item.scheme_unit === 'month'" class="ml">
                  {{ item.scheme_price | currency }} / 月
                </span>
                <span v-if="item.scheme_unit === 'once'" class="ml">
                  {{ item.scheme_price | currency }} / 一次性
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="flex-center mb">
        <el-button class="extend" @click="dialogShow = false">取消</el-button>
        <el-button class="extend" type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>
    
    <f-table-footer :list="equips" :selection="multiSelection" @toggle="toggleAll" checkbox class="main-footer-fix" style="padding-left: 38px">
      <el-button type="success" size="small" :disabled="multiSelection.length === 0" :plain="multiSelection.length === 0" @click="showBatchSetDialog">批量设置</el-button>
      <template slot="right">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
      </template>
    </f-table-footer>

    <ei-addvalue-equip-charge :show.sync="batchDialogShow" :schemes="selectSchemes" :equips="multiSelection" @submit="fetchData()" />
  </div>
</template>

<script>
import { addvalueListApi, allSchemeApi, postConfigApi } from '@/api/ei/eiApi'
import { getallApi } from '@/api/fam/famTagApi'

export default {
  name: 'EiRms',

  components: {
    TagPanel: () => import('@/views/fam/components/TagPanel'),
    ApDatePicker: () => import('@/views/ap/components/ApDatePicker'),
    EiAddvalueEquipCharge: () => import('./components/EiAddvalueEquipCharge')
  },

  data() {
    return {
      activeStatusArr: [
        { key: 1, value: '未激活' },
        { key: 2, value: '已激活' }
      ],
      status: [
        { key: 1, value: '正常' },
        { key: 2, value: '已过期' }
      ],

      tags: [],
      schemes: [],
      selectSchemes: [],

      loading: false,
      query: {
        active_status: null,
        rms_status: this.$route.query.status ? parseInt(this.$route.query.status) : null,
        rms_schemeid: null,
        keyword: '',
        tagid: undefined,
        devid: undefined,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      allFilterShow: Number(localStorage.getItem(`__FILTER_ALL_SHOW_EIRMS__`)),
      equips: [],
      total: 0,

      activeRow: {},
      dialogShow: false,
      formData: {
        rms_schemeid: null
      },
      posting: false,

      multiSelection: [],
      batchDialogShow: false,

      sortOptions: [
        { value: 0, title: "最近创建" },
        { value: 10, title: "最早到期" },
        { value: 9, title: "最晚到期" },
      ],
    }
  },

  computed: {
    schemesObj() {
      const obj = {}
      this.schemes.forEach(v => {
        obj[v.schemeid] = v
      })
      return obj
    },

    authObj() {
      return this.$store.getters.authObj
    }
  },

  created() {
    const keepAlivePath = [
      '/rms/equip/detail',
      '/rms/member/detail',
      '/dev/detail',
    ]
    this.query = this.$utils.initListQuery(this.query, keepAlivePath)
    this.fetchData()
    this.fetchScheme()
    this.fetchTag()
    // this.fetchDev()
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query)
    next()
  },

  methods: {
    toggleAll() {
      this.$refs.equipsTable.toggleAllSelection()
    },

    fetchData(page) {
      if (page) this.query.pindex = page
      this.loading = true
      addvalueListApi(this.query).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.equips = res.data.list
          this.total = res.data.total
        }
      })
    },

    fetchScheme() {
      allSchemeApi().then(res => {
        if (res.errno === 0) {
          const arr = [{ schemeid: 0, title: '未加载' }]
          this.selectSchemes = res.data.list
          this.schemes = arr.concat(res.data.list)
        }
      })
    },

    fetchTag() {
      getallApi({ type: 'equip' }).then(res => {
        if (!res.errno) {
          this.tags = res.data.list
        }
      })
    },

    showAllFilter(val) {
      this.allFilterShow = val
      localStorage.setItem(`__FILTER_ALL_SHOW_EIRMS__`, val)
    },

    showSingleSetDialog(row) {
      this.activeRow = Object.assign({}, row)
      this.formData.rms_schemeid = this.activeRow.rms_schemeid ? this.activeRow.rms_schemeid : null
      this.dialogShow = true
    },

    submit() {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          const temp = {
            equipid: this.activeRow.equipid,
            rms_schemeid: this.formData.rms_schemeid
          }
          postConfigApi(temp).then(res => {
            if (!res.errno) {
              this.dialogShow = false
              this.$message.success(res.message)
              this.fetchData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    handleSelectionChange(val) {
      this.multiSelection = val
    },
    showBatchSetDialog() {
      if (!this.multiSelection.length) return this.$message.error('请先选择设备！')
      this.batchDialogShow = true
    },

    toDoc() {
      window.open('https://wiki.frippler.com/#/docs/fs/fcs/39')
    },

  }
}
</script>

<style lang="scss" scoped>
.circle-btn {
  border: 0;
}
</style>
